<!-- =========================================================================================
  File Name: ScheduleViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>ASSIGN A SCHEDULE</h4>
        <!-- <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} SCHEDULE</h4> -->
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
  <div class="pl-6 pr-6 pt-6">
        <div class="flex">
          <!-- <vs-checkbox v-model="ExBox" @change="excheck(ExBox)">Choose Schedule</vs-checkbox> -->
          <vs-checkbox v-model="NewBox" @change="newcheck(NewBox)">Add New</vs-checkbox>
        </div>
        <br>
      <div v-if="ExBox" >
        <label class="vs-select--label w-full">Select An Existing Schedule</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="dataSchedule"  :options="schedules"  />
        <span v-if="dataSchedule">
          <p v-for="(scheduledate, index) in dataSchedule.scheduledates" :key="index"  class="product-name font-medium truncate" >
             {{scheduledate.day}}   {{scheduledate.start_time}} {{scheduledate.end_time}}
          </p>
       </span>
        </div>
  </div>
     <div class="p-3" v-if="NewBox">
      <!-- NAME -->
        <vs-input label="Schedule Name" v-model="currrent_schedule.name" class="mt-5 w-full" name="item-name" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
      <div class="slot-fields" v-for="(date, index) in currrent_schedule.dates" :key="index">
        <br>{{index}}
    <div class="slot-fields" v-for="(item, dayindex) in date" :key="dayindex">
    <small style="color:red">{{getTime(index,dayindex,item.start_time,item.end_time)}}</small>
   <flat-pickr v-model="item.start_time" :config="configdateTimePicker" class="picker" name="start_time" placeholder="Start time"/>
   <flat-pickr v-model="item.end_time" :config="configdateTimePicker" class="picker" name="end_time" placeholder="End time"/><span class="danger" @click="inputRemove(index,dayindex)" style="color:red">x</span>
    </div>
    <div  class="slot-actions pr-2 mt-1 " style="float:right;clear:both">
    <vs-button color="primary" size="small" @click="inputAdd(index)"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/></vs-button>
     </div>
        </div>
      </div>
   <!-- <div class="pl-3" v-if="ViewBox==true && oldSchedule!==null">
     <h5>{{oldSchedule.name}}</h5>
       <p  v-for="(scheduledate, index) in oldSchedule.scheduledates" :key="index"  class="product-name font-medium truncate"  >
             {{scheduledate.day}}   {{scheduledate.start_time}} {{scheduledate.end_time}}
        </p>
        <vs-button v-if="oldSchedule.name" size="small" style="float:center" color="danger" class="ml-2" @click="oldRemove">Remove</vs-button>
      </div>  -->
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button  class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {CREATE_SCHEDULE,UPDATE_SCHEDULE,ALL_SCHEDULE} from '@/graphql'
import {UPDATE_LOCATION} from '@/graphql'


export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    moment
  },
  data () {
    return {
      dataId: null,
      dataName: '',
      ExBox:true,
      NewBox:false,
      // ViewBox:true,
      dataSibling:'',
      dataSchedule:[],
      settings: { // perfectscrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: .60
      },
      oldSchedule:'',
       currrent_schedule:
        {
          "id": "",
          "name": "",
          dates: {
            Monday: [
              {
                "start_time": "",
                "end_time": "",
              }
            ],
            Tuesday: [
              {
              "start_time": "",
              "end_time": "",
            }
            ],
            Wednesday: [
              {
              "start_time": "",
              "end_time": "",
            }
            ],
           Thursday: [
            {
              "start_time": "",
              "end_time": "",
            }
            ],
          Friday: [
            {
              "start_time": "",
              "end_time": "",
            }
            ],
          Saturday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          Sunday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          }
        },
        configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: "H:i",
        time_24hr: false,
        altInput: true,
        dateFormat: "H:i",
      },
      schedules:[],
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id,name,schedule} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataName = name
        this.dataSchedule=schedule
        // this.oldSchedule = schedule.scheduledates
        // this.schedules = schedule
        // this.oldSchedule = schedule
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    // schedules() {
    //   return this.$store.state.dataList.schedules
    // },
    isFormValid () {
       if(this.ExBox){
      return !this.errors.any() && this.dataSchedule
    }
    if(this.NewBox){
      return !this.errors.any() && this.currrent_schedule.name
    }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
  },
  methods: {
    getTime(day,index,start_time,end_time){
    var space="  "
    if(start_time.toString()!='' && end_time.toString()!=''){
    if (end_time > start_time){
       return ""
    }
    else
    {
     return "End Time is Less than Start Time at " + day +  space + (index+1)
    }
    }
    },
     inputAdd(dayindex) {
      var index = this.currrent_schedule.dates[dayindex].length
      this.currrent_schedule.dates[dayindex].push({
        "start_time": "",
        "end_time": "",
      });
    },
    inputRemove(index,dayindex) {
      if(this.currrent_schedule.dates[index][dayindex].id){
        this.deletedschedules.push(this.currrent_schedule.dates[index][dayindex].id)
      }
      this.currrent_schedule.dates[index].splice(dayindex, 1);
    },
    initValues () {
      this.currrent_schedule=
        {
          "id": "",
          "name": "",
          dates: {
            Monday: [
              {
                "start_time": "",
                "end_time": "",
              }
            ],
            Tuesday: [
              {
              "start_time": "",
              "end_time": "",
            }
            ],
            Wednesday: [
              {
              "start_time": "",
              "end_time": "",
            }
            ],
           Thursday: [
            {
              "start_time": "",
              "end_time": "",
            }
            ],
          Friday: [
            {
              "start_time": "",
              "end_time": "",
            }
            ],
          Saturday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          Sunday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          }
        },
      this.ExBox=true
      this.NewBox=false
      // this.ViewBox=true
      },
    oldRemove(){
        this.oldSchedule=''
         this.$apollo
          .mutate({
           mutation: UPDATE_LOCATION,
           variables: {
            id :this.dataId,
            name:this.dataName,
            schedule_id:this.oldSchedule
          }
        })
        .then(response => {
          if (response){
            this.StatusSuccess("Deleted")
            this.initValues()
          }
        })
        .catch(error => {
           this.StatusFail()
        });
          this.$emit('closeSidebar')
          this.dataSchedule = []
          this.ExBox=true
          this.NewBox=false
          // this.ViewBox=true
          this.initValues()
    },
  StatusSuccess(status) {
      this.$vs.notify({
        title: "Schedule",
        text: 'Location Schedule '+status+' Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
StatusFail() {
      this.$vs.notify({
        title: "Schedule",
        text: 'Location Schedule Failed to Created!',
        color: 'success',
        position: 'top-right'
      })
    },
    submitData () {
       if(this.ExBox){
      this.$validator.validateAll().then(result => {
        if(this.dataSchedule){
         this.dataSchedule=this.dataSchedule.id
        }
        if (result) {
           this.$apollo
          .mutate({
           mutation: UPDATE_LOCATION,
           variables: {
            id :this.dataId,
            name:this.dataName,
            schedule_id: this.dataSchedule,
          }
        })
        .then(response => {
          if (response){
           this.StatusSuccess("Changed")
          }
        }) .catch(error => {


      });
          this.$emit('closeSidebar')
          this.dataSchedule = []
          this.ExBox=true
          this.NewBox=false
          // this.ViewBox=false
          this.initValues()
        }
      })
      }
      if(this.NewBox) {
         var finalschedule=[]
     for (let i = 0; i <this.currrent_schedule.dates.Monday.length; i++) {
       var element = this.currrent_schedule.dates.Monday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
          {
            element["day"] = "Monday"
            finalschedule.push(element)
          }
    }
    for (let i = 0; i <this.currrent_schedule.dates.Tuesday.length; i++) {
       var element = this.currrent_schedule.dates.Tuesday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
          {
              element["day"] = "Tuesday"
              finalschedule.push(element)
          }
      }
    for (let i = 0; i <this.currrent_schedule.dates.Wednesday.length; i++) {
       var element = this.currrent_schedule.dates.Wednesday[i];
        if(element['start_time'] != '' && element['end_time'] != '' )
          {
                element["day"] = "Wednesday"
                finalschedule.push(element)
          }
    }
    for (let i = 0; i <this.currrent_schedule.dates.Thursday.length; i++) {
       var element = this.currrent_schedule.dates.Thursday[i];
        if(element['start_time'] != '' && element['end_time'] != '' )
          {
                 element["day"] = "Thursday"
                 finalschedule.push(element)
          }
    }
    for (let i = 0; i <this.currrent_schedule.dates.Friday.length; i++) {
       var element = this.currrent_schedule.dates.Friday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
        {
          element["day"] = "Friday"
          finalschedule.push(element)
        }
    }
     for (let i = 0; i <this.currrent_schedule.dates.Saturday.length; i++) {
       var element = this.currrent_schedule.dates.Saturday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
        {
          element["day"] = "Saturday"
          finalschedule.push(element)
        }
    }
     for (let i = 0; i <this.currrent_schedule.dates.Sunday.length; i++) {
       var element = this.currrent_schedule.dates.Sunday[i];
      if(element['start_time'] != '' && element['end_time'] != '' )
       {
         element["day"] = "Sunday"
         finalschedule.push(element)
       }
    }
    var error=0
    checkSchedule(finalschedule);
    function checkSchedule(finalschedule){
      for (let i = 0; i < finalschedule.length; i++) {
      if (finalschedule[i].end_time <= finalschedule[i].start_time){
         error++
      }
    }
    }
    this.$validator.validateAll().then(result => {
        if (result && error==0) {
           if(finalschedule.length>0){
          this.$apollo
          .mutate({
           mutation: CREATE_SCHEDULE,
          variables: {
          name:this.currrent_schedule.name,
          scheduledates: {
          create:finalschedule
          },
          }
        })
        .then(response => {
          if (response){
          this.$apollo
          .mutate({
           mutation: UPDATE_LOCATION,
           variables: {
            id :this.dataId,
            name:this.dataName,
            schedule_id:response.data.createSchedule.id
          }
        })
        .then(response => {
          if (response){
            this.StatusSuccess("Created")
             this.$emit('closeSidebar')
            this.initValues()
          }
        })
      }
        }) .catch(error => {
           this.StatusFail()
        });
        }
      }
      })
      }
        },
     excheck(val){
      this.NewBox=!val
    },
     newcheck(val){
       this.ExBox=!val
    },
    //   excheck(val){
    //   if(val){
    //   this.NewBox=!val
    //   // this.ViewBox=!val
    //   }
    //   // else{
    //   //   this.ViewBox=true
    //   // }
    // },
    // // newcheck(val){
    // //   if(val){
    // //   this.ExBox=!val
    // //   // this.ViewBox=!val
    // //   }
    // //   // else{
    // //   //   this.ViewBox=true
    // //   // }
    // // },
  },
   created () {
      this.$apollo
      .mutate({
        mutation: ALL_SCHEDULE,
          variables: {
           status:1
     },
      })

      .then(response => {
        this.schedules=response.data.schedules
      })
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}
.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
.picker{
  width: 175px;
}
</style>
